import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';

export const StoreBookingEvents: AnalyticsBrandSettings = {
  reservaEnTiendaReservaEnTiendaErrorReserva(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'reserva_en_tienda', 'reserva_en_tienda', 'error_reserva', field);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  reservaEnTiendaReservaEnTiendaErrorServidorReserva(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const label = `cod_${componentData.errorCode}-desc_${componentData.errorDescription}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'reserva_en_tienda', 'reserva_en_tienda', 'error_servidor_reserva', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings)
  },

  reservaEnTiendaReservaEnTiendaReservarOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, helpers } = data;
    const store = componentData.physicalStore?.id
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'reserva_en_tienda', 'reserva_en_tienda', 'reservar_ok', store);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string[] = ['20', '83'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  reservaEnTiendaReservaEnTiendaSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'reserva_en_tienda', 'reserva_en_tienda', 'seleccionar_talla', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string [] = ['20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  reservaEnTiendaReservaEnTiendaSeleccionarLargo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'reserva_en_tienda', 'reserva_en_tienda', 'seleccionar_largo', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string [] = ['20', '14'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  reservaEnTiendaLegalVerPoliticaPrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'reserva_en_tienda', 'ver_politica_privacidad');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

}
